import { Event } from '@sentry/angular';

// The Safari stack parser of @sentry/browser 6.16.1 does not know the ionic: scheme of the iOS app. It reads
// `s@ionic://localhost/main.<hash>.js` right only when a digit precedes `.js`; with a hash ending in a letter
// `@ionic:` sticks to the function name and the file loses its scheme, so Sentry never matches the source
// maps and the whole build stays minified (#384).
const BROKEN_FUNCTION_SUFFIX = '@ionic:';
const BROKEN_FILE_PREFIX = '//localhost/';

export function restoreIonicFrames(event: Event): void {
  const exceptions = (event.exception && event.exception.values) || [];
  for (const exception of exceptions) {
    const frames = (exception.stacktrace && exception.stacktrace.frames) || [];
    for (const frame of frames) {
      if (frame.filename && frame.filename.startsWith(BROKEN_FILE_PREFIX)
        && frame.function && frame.function.endsWith(BROKEN_FUNCTION_SUFFIX)) {
        frame.filename = 'ionic:' + frame.filename;
        frame.function = frame.function.slice(0, -BROKEN_FUNCTION_SUFFIX.length) || '?';
      }
    }
  }
}
